import {
	FormControlLabel,
	FormGroup,
	Grid,
	InputLabel,
	Stack,
	styled,
	Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { api, types } from "api";
import {
	accuracySeries,
	outSchoolMetrics,
	RealmsTopic,
	RoleType,
	SchoolMetrics,
} from "api/types";
import { ComponentProps, Loader } from "components/Loader";
import { IOSSwitch } from "components/SwitchButton/SwitchButton";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DownloadDialog } from "../../components/DownloadDialog/DownloadDialog";
import { useAuthStatus } from "../../helpers/useAuthStatus";
import { ActivityAccuracy } from "./Component/ActivitiesAccuracy";
import { ActivityCount } from "./Component/ActivityCount";
// import { YearLevel } from "./YearLevel";
import { CompletionRate } from "./Component/CompletionRate";
import { EnrollmentDistribution } from "./Component/EnrollmentDistribution";
import { RealmSelectBar } from "./RealmSelect";
const PREFIX = "TeacherMetricsPage";
let apiResponse: outSchoolMetrics;
const classes = {
	root: `${PREFIX}-root`,
	button: `${PREFIX}-button`,
	title: `${PREFIX}-title`,
	groupList: `${PREFIX}-groupList`,
	summaryCard: `${PREFIX}-summaryCard`,
	summaryTitle: `${PREFIX}-summaryTitle`,
	summaryText: `${PREFIX}-summaryText`,
	icon: `${PREFIX}-icon`,
	bluePaper: `${PREFIX}-bluePaper`,
	Card: `${PREFIX}-Card`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		padding: 20,
	},
	[`& .${classes.summaryCard}`]: {
		marginTop: 30,
		minHeight: 370,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
	},
	[`& .${classes.Card}`]: {
		marginTop: 30,
		minHeight: 80,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
	},
	[`& .${classes.bluePaper}`]: {
		marginTop: 30,
		minHeight: 80,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
		backgroundColor: theme.palette.primary.main,
	},
}));

const calibrateMonth = (accuracyData: SchoolMetrics[]): Array<any> => {
	const d = new Date();
	const year = d.getFullYear();
	const month_num = d.getMonth();
	const accuracyArray = [
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
		"-",
	] as Array<any>;
	for (const item of accuracyData) {
		if (item.Year === year) {
			accuracyArray[11 - (month_num + 1 - item.Month_num)] =
				item.AccuracyRate * 100;
		}
		if (item.Year === year - 1) {
			if (item.Month_num > 12 - (11 - month_num)) {
				accuracyArray[item.Month_num - (12 - (11 - month_num)) - 1] =
					item.AccuracyRate * 100;
			}
		}
	}
	return accuracyArray;
};

export const TeacherMetricsPage = ({
	setLoading,
}: ComponentProps): JSX.Element => {
	const { role } = useAuthStatus();
	// const [rate,setRate] = useState([50]);
	// const [month,setMonth] = useState([ ""])
	const lastrealm = React.useRef<string[]>([]);
	const { groupId } = useParams<{ groupId: types.UUID }>();
	const [groupName, setGroupName] = useState("");
	const [accuracyDataArray, setAccuracy] = useState<accuracySeries[]>([]);
	const [month, setMonth] = useState([""]);
	const [activity, setActivity] = useState([{}]);
	const [rate, setRate] = useState([50]);
	const [topic, setTopic] = useState(false);
	const [fetch, setFetch] = useState(false);
	const [startMonth, setStartMonth] = useState(1);
	const [startyear, setStartYear] = useState(1970);
	const [realm, setRealm] = useState<string[]>([
		"E=MC Square",
		"Cape Cosmos",
		"Green Acres",
		"Prehistoric Point",
		"Edison's Isle",
		"Elixir Institute",
		"DNAtion",
		"Fahren Heights",
		"Pythagoras Peninsula",
		"Habiterra",
	]);
	const [imgUrlMap, setImgUrlMap] = useState(new Map<string, string>());
	const handleSwitch = (): void => {
		setTopic(topic ? false : true);
		const convert_: string[] = [];
		for (const item of realm) {
			convert_.push(RealmsTopic[item]!);
		}
		setRealm(convert_);
	};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleResult = (
		res: outSchoolMetrics,
		month_num: number,
		year: number,
	): void => {
		const filter_res = res.MetricsList.filter(function (a) {
			if (a.Year > year) {
				return true;
			} else if (a.Year === year && a.Month_num >= month_num) {
				return true;
			} else {
				return false;
			}
		});
		setRate(filter_res.map((a) => a.CompleteRate * 100));
		setMonth(filter_res.map((a) => a.Month));
		setMonth(filter_res.map((a) => a.Month));
		const accuracyData: accuracySeries[] = [];
		accuracyData.push({
			name: groupName,
			data: calibrateMonth(res.MetricsList),
			type: "line",
			markPoint: {
				data: [
					{ type: "max", name: "Max" },
					// { type: "min", name: "Min" },
				],
			},
		});
		setAccuracy(accuracyData);
		const MonthlyData = filter_res.map((a) => a.MonthlyDataList);
		const ActivityArray = [];
		let Realm: string[] = [];
		if (topic) {
			for (const item of realm) {
				Realm.push(RealmsTopic[item]!);
			}
		} else {
			Realm = realm;
		}
		for (let item of MonthlyData) {
			item = item.filter(function (a) {
				if (Realm.includes(a.LearningArea)) {
					return true;
				} else {
					return false;
				}
			});
			ActivityArray.push(
				Object.assign(
					{},
					...item.map((x) => ({ [x.LearningArea]: x.Activity })),
				),
			);
		}
		setActivity(ActivityArray);
	};

	const fetchResult = useCallback(() => {
		// no userId given
		api
			.getGroupMetrics(groupId)
			.then((res) => {
				api
					.getGroup(groupId)
					.then((resp) => {
						if (resp.status !== 200) {
							throw new Error();
						}
						setGroupName(resp.data.name);
					})
					.catch(() => {});

				if (res.status !== 200) {
					throw new Error();
				}
				apiResponse = res.data;
				handleResult(apiResponse, 1, 1970);
				setLoading(false);
				setFetch(true);
			})
			.catch(() => {});
	}, [groupId, handleResult, setLoading]);

	useEffect(() => {
		fetchResult();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (fetch && realm !== lastrealm.current) {
			lastrealm.current = realm;
			handleResult(apiResponse, startMonth, startyear);
		}
	}, [fetch, handleResult, realm, startMonth, startyear]);

	const [recent, setRecent] = React.useState("All");

	const handleRecentChange = (event: SelectChangeEvent): void => {
		const d = new Date();
		let month_num = d.getMonth();
		let year = d.getFullYear();
		switch (event.target.value) {
			case "One Month":
				[year, month_num] = calculateDate(year, month_num + 1, 1);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			case "Three Month":
				[year, month_num] = calculateDate(year, month_num + 1, 3);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			case "One Year":
				[year, month_num] = calculateDate(year, month_num + 1, 12);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			default:
				handleResult(apiResponse, 1, 1970);
				break;
		}
		setRecent(event.target.value);
	};
	const calculateDate = (
		year_now: number,
		month_now: number,
		time_span: number,
	): [number, number] => {
		if (month_now - time_span <= 0) {
			year_now -= 1;
			month_now += 12;
			month_now -= time_span;
		} else {
			month_now -= time_span;
		}
		return [year_now, month_now];
	};

	const onDownload = (urls: [string, string]): void => {
		imgUrlMap.set(urls[0], urls[1]);
		setImgUrlMap(imgUrlMap);
	};

	return (
		<Root className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={8}>
					<Typography variant="h2" data-testid="hello">
						{groupName} - Metrics
					</Typography>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.bluePaper}>
						<Stack direction="row" justifyContent="space-between">
							<Stack direction="row" spacing={10}>
								<Paper
									component="form"
									sx={{
										p: "2px 4px",
										display: "flex",
										alignItems: "center",
										minwidth: 200,
									}}
								>
									{/* <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DateRangePicker
										startText="Start Date"
										endText="End Date"
										value={date}
										onChange={(newDate) => {
											setDate(newDate);
										}}
										renderInput={(startProps, endProps) => (
											<React.Fragment>
												<TextField {...startProps} />
												<Box sx={{ mx: 2 }}> - </Box>
												<TextField {...endProps} />
											</React.Fragment>
										)}
									/>
								</LocalizationProvider> */}
									<FormControl sx={{ m: 1, minWidth: 200 }}>
										<InputLabel id="period-select-label">
											Select a Period
										</InputLabel>
										<Select
											value={recent}
											onChange={handleRecentChange}
											labelId="period-select-label"
											label="Select a Period"
											defaultValue="All"
											// displayEmpty
											// inputProps={{ "aria-label": "Without label" }}
										>
											<MenuItem value="All">All</MenuItem>
											<MenuItem value="One Month">Recent One Month</MenuItem>
											<MenuItem value="Three Month">
												Recent Three Months
											</MenuItem>
											<MenuItem value="One Year">Recent One Year</MenuItem>
										</Select>
									</FormControl>
								</Paper>

								<FormGroup>
									<Stack direction="row" spacing={1} alignItems="center">
										<Typography color="common.white">Realm</Typography>
										<FormControlLabel
											control={<IOSSwitch sx={{ m: 1 }} />}
											label=""
											onChange={handleSwitch}
										/>
										<Typography color="common.white">Topic</Typography>
									</Stack>
								</FormGroup>
							</Stack>
							<Stack direction="row" alignItems="flex-start">
								<DownloadDialog
									role={role as RoleType}
									loading={false}
									baseName={"Metrics Results"}
									resultToBeRendered={{
										imageURLs: imgUrlMap,
									}}
									templateType={"metrics"}
								/>
							</Stack>
						</Stack>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper className={classes.Card}>
						<RealmSelectBar realm={realm} setRealm={setRealm} Topic={topic} />
					</Paper>
				</Grid>
				<Grid item xs={7}>
					<Paper className={classes.summaryCard}>
						<ActivityCount
							value={activity}
							month={month}
							topic={topic}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>
				<Grid item xs={5}>
					<Paper className={classes.summaryCard}>
						<EnrollmentDistribution
							value={activity}
							topic={topic}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>

				<Grid item xs={6}>
					<Paper className={classes.summaryCard}>
						<CompletionRate
							value={rate}
							month={month}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>
				<Grid item xs={6}>
					<Paper className={classes.summaryCard}>
						<ActivityAccuracy
							onDownload={onDownload}
							data={accuracyDataArray}
						/>
					</Paper>
				</Grid>
			</Grid>
		</Root>
	);
};

export const TeacherMetricsLoadingPage = Loader(
	TeacherMetricsPage,
	"We are fetching your data",
);
